import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const adminHeaders = () => {
    const t = localStorage.getItem("wappit_admin_token");
    return t ? {
        Authorization: `Bearer ${t}`
    } : {};
};

// ── Public ──
export const listPosts = (params = {}) => axios.get(`${API}/blog/posts`, {
    params
}).then((r) => r.data);
export const getPost = (slug) => axios.get(`${API}/blog/posts/${slug}`).then((r) => r.data);
export const trackView = (slug) => axios.post(`${API}/blog/posts/${slug}/view`).then((r) => r.data).catch(() => null);
export const listCategories = () => axios.get(`${API}/blog/categories`).then((r) => r.data);
export const listTags = () => axios.get(`${API}/blog/tags`).then((r) => r.data);
export const searchPosts = (q) => axios.get(`${API}/blog/search`, {
    params: {
        q
    }
}).then((r) => r.data);

// ── Admin ──
const adminGet = (p, params) => axios.get(`${API}/admin/blog${p}`, {
    headers: adminHeaders(),
    params
}).then((r) => r.data);
const adminPost = (p, body) => axios.post(`${API}/admin/blog${p}`, body, {
    headers: adminHeaders()
}).then((r) => r.data);
const adminPut = (p, body) => axios.put(`${API}/admin/blog${p}`, body, {
    headers: adminHeaders()
}).then((r) => r.data);
const adminDel = (p) => axios.delete(`${API}/admin/blog${p}`, {
    headers: adminHeaders()
}).then((r) => r.data);

export const adminListPosts = (params) => adminGet("/posts", params);
export const adminGetPost = (id) => adminGet(`/posts/${id}`);
export const adminCreatePost = (body) => adminPost("/posts", body);
export const adminUpdatePost = (id, body) => adminPut(`/posts/${id}`, body);
export const adminDeletePost = (id) => adminDel(`/posts/${id}`);
export const adminDuplicate = (id) => adminPost(`/posts/${id}/duplicate`, {});
export const adminPublish = (id) => adminPost(`/posts/${id}/publish`, {});
export const adminUnpublish = (id) => adminPost(`/posts/${id}/unpublish`, {});
export const adminArchive = (id) => adminPost(`/posts/${id}/archive`, {});
export const adminSchedule = (id, when) => adminPost(`/posts/${id}/schedule`, {
    scheduled_for: when
});

export const adminListCats = () => adminGet("/categories");
export const adminCreateCat = (b) => adminPost("/categories", b);
export const adminUpdateCat = (id, b) => adminPut(`/categories/${id}`, b);
export const adminDeleteCat = (id) => adminDel(`/categories/${id}`);

export const adminListTags = () => adminGet("/tags");
export const adminCreateTag = (b) => adminPost("/tags", b);
export const adminUpdateTag = (id, b) => adminPut(`/tags/${id}`, b);
export const adminDeleteTag = (id) => adminDel(`/tags/${id}`);

export const adminListAuthors = () => adminGet("/authors");
export const adminCreateAuthor = (b) => adminPost("/authors", b);
export const adminUpdateAuthor = (id, b) => adminPut(`/authors/${id}`, b);
export const adminDeleteAuthor = (id) => adminDel(`/authors/${id}`);

export const adminAnalytics = () => adminGet("/analytics");

// Utility: resolve an upload path to absolute URL
export const absoluteUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    if (url.startsWith("/uploads")) return `${process.env.REACT_APP_BACKEND_URL}/api/storage${url}`;
    return `${process.env.REACT_APP_BACKEND_URL}${url}`;
};